import { ExportColumn, ExportStyles, TcsTdsOption } from '../types';

export const salesExportColumns: ExportColumn[] = [
  { header: 'Invoice Date', accessor: 'invoice_date', formatType: 'date' },
  { header: 'Invoice No', accessor: 'invoice_no', formatType: 'text' },
  { header: 'Customer Name', accessor: 'customer_name', formatType: 'text' },
  { header: 'Customer Legal Name', accessor: 'customer_legal_name', formatType: 'text' },
  { header: 'Taxabillity', accessor: 'invoice_taxability', formatType: 'text' },
  { header: 'Customer Category', accessor: 'customer_category', formatType: 'text' },
  { header: 'Customer GSTIN', accessor: 'customer_gstin', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'place_of_supply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billing_currency', formatType: 'currency_name' },
  { header: 'Taxable Value', accessor: 'taxable_value', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'IGST Rate', accessor: 'igst_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'IGST Amount', accessor: 'igst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'CGST Rate', accessor: 'cgst_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'CGST Amount', accessor: 'cgst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'SGST/UTGST Rate', accessor: 'sgst_utgst_rate', formatType: 'number' , cellStyle: 'custonCurrenctStyle'},
  { header: 'SGST/UTGST Amount', accessor: 'sgst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'Cess Rate', accessor: 'cess_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'Cess Amount', accessor: 'cess_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: '(-)Additional Discount', accessor: 'additional_discount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS Amount', accessor: 'tcs_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Round Off', accessor: 'round_off', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Total GST Amount', accessor: 'total_gst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Gross invoice value', accessor: 'gross_invoice_value', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Net Amount', accessor: 'net_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Status', accessor: 'status', formatType: 'text' },
  // { header: 'Invoice Amount', accessor: 'invoice_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Due Date', accessor: 'due_date', formatType: 'date' },
  { header: 'Due in Overdue Days', accessor: 'due_in_overdue_days', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
];
export const purchaseExportColumns: ExportColumn[] = [
  { header: 'Invoice Date', accessor: 'invoice_date', formatType: 'date' },
  { header: 'Invoice No', accessor: 'invoice_no', formatType: 'text' },
  { header: 'Supplier Name', accessor: 'supplier_name', formatType: 'text' },
  { header: 'Supplier Legal Name', accessor: 'supplier_legal_name', formatType: 'text' },
  { header: 'Taxabillity', accessor: 'invoice_taxability', formatType: 'text' },
  { header: 'Supplier Category', accessor: 'supplier_category', formatType: 'text' },
  { header: 'Supplier GSTIN', accessor: 'supplier_gstin', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'place_of_supply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billing_currency', formatType: 'currency_name' },
  { header: 'Taxable Value', accessor: 'taxable_value', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'IGST Rate', accessor: 'igst_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'IGST Amount', accessor: 'igst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'CGST Rate', accessor: 'cgst_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'CGST Amount', accessor: 'cgst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'SGST/UTGST Rate', accessor: 'sgst_utgst_rate', formatType: 'number' , cellStyle: 'custonCurrenctStyle'},
  { header: 'SGST/UTGST Amount', accessor: 'sgst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  // { header: 'Cess Rate', accessor: 'cess_rate', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
  { header: 'Cess Amount', accessor: 'cess_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: '(-)Additional Discount', accessor: 'additional_discount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS Amount', accessor: 'tcs_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Round Off', accessor: 'round_off', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Total GST Amount', accessor: 'total_gst_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Gross invoice value', accessor: 'gross_invoice_value', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Net Amount', accessor: 'net_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Status', accessor: 'status', formatType: 'text' },
  // { header: 'Invoice Amount', accessor: 'invoice_amount', formatType: 'currency', cellStyle: 'custonCurrenctStyle' },
  { header: 'Due Date', accessor: 'due_date', formatType: 'date' },
  { header: 'Due in Overdue Days', accessor: 'due_in_overdue_days', formatType: 'number', cellStyle: 'custonCurrenctStyle' },
];
export const creditExportColumns: ExportColumn[] = [
  { header: 'Credit Note Date', accessor: 'note_date', formatType: 'date' },
  { header: 'Credit Note No', accessor: 'note_no', formatType: 'text' },
  { header: 'Sales Invoice No', accessor: 'party_invoice_no', formatType: 'text' },
  { header: 'Customer/Supplier Name', accessor: 'party_name', formatType: 'text' },
  { header: 'Customer/Supplier Legal Name', accessor: 'party_legal_name', formatType: 'text' },
  { header: 'Taxability', accessor: 'note_taxability', formatType: 'text' },
  { header: 'Customer/Supplier Category', accessor: 'party_category', formatType: 'text' },
  { header: 'Customer/Supplier GSTIN', accessor: 'party_gstin', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'place_of_supply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billing_currency', formatType: 'currency_name' },
  { header: 'Taxable Value', accessor: 'taxable_value', formatType: 'text' },
  { header: 'IGST Amount', accessor: 'igst_amount', formatType: 'currency' },
  { header: 'CGST Amount', accessor: 'cgst_amount', formatType: 'currency' },
  { header: 'CGST/ UTGST Amount', accessor: 'sgst_amount', formatType: 'currency' },
  { header: 'Cess Amount', accessor: 'cess_amount', formatType: 'currency' },
  { header: 'Additional Discount', accessor: 'additional_discount', formatType: 'currency' },
  { header: 'TCS Amount', accessor: 'tcs_amount', formatType: 'currency' },
  { header: 'Round Off', accessor: 'round_off', formatType: 'currency' },
  { header: 'Total GST Amount', accessor: 'total_gst_amount', formatType: 'currency' },
  { header: 'Gross Amount', accessor: 'gross_note_value', formatType: 'currency' },
  { header: 'Status', accessor: 'status', formatType: 'text' },
  { header: 'Net Amount', accessor: 'net_amount', formatType: 'text' },
  { header: 'Due Date', accessor: 'due_date', formatType: 'date' },
  { header: 'Due in/Over Due', accessor: 'due_in_overdue_days', formatType: 'text' },
];
export const DebitExportColumns: ExportColumn[] = [
  { header: 'Debit Note Date', accessor: 'note_date', formatType: 'date' },
  { header: 'Debit Note No', accessor: 'note_no', formatType: 'text' },
  { header: 'Purchase Invoice No', accessor: 'party_invoice_no', formatType: 'text' },
  { header: 'Customer/Supplier Name', accessor: 'party_name', formatType: 'text' },
  { header: 'Customer/Supplier Legal Name', accessor: 'party_legal_name', formatType: 'text' },
  { header: 'Taxability', accessor: 'note_taxability', formatType: 'text' },
  { header: 'Customer/Supplier Category', accessor: 'party_category', formatType: 'text' },
  { header: 'Customer/Supplier GSTIN', accessor: 'party_gstin', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'place_of_supply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billing_currency', formatType: 'currency_name' },
  { header: 'Taxable Value', accessor: 'taxable_value', formatType: 'text' },
  { header: 'IGST Amount', accessor: 'igst_amount', formatType: 'currency' },
  { header: 'CGST Amount', accessor: 'cgst_amount', formatType: 'currency' },
  { header: 'CGST/ UTGST Amount', accessor: 'sgst_amount', formatType: 'currency' },
  { header: 'Cess Amount', accessor: 'cess_amount', formatType: 'currency' },
  { header: 'Additional Discount', accessor: 'additional_discount', formatType: 'currency' },
  { header: 'TCS Amount', accessor: 'tcs_amount', formatType: 'currency' },
  { header: 'Round Off', accessor: 'round_off', formatType: 'currency' },
  { header: 'Total GST Amount', accessor: 'total_gst_amount', formatType: 'currency' },
  { header: 'Gross Amount', accessor: 'gross_note_value', formatType: 'currency' },
  { header: 'Status', accessor: 'status', formatType: 'text' },
  { header: 'Net Amount', accessor: 'net_amount', formatType: 'text' },
  { header: 'Due Date', accessor: 'due_date', formatType: 'date' },
  { header: 'Due in/Over Due', accessor: 'due_in_overdue_days', formatType: 'text' },
];
export const tdsExportColumns: ExportColumn[] = [
  { header: 'Date of deduction', accessor: 'invoicedate', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher No', accessor: 'vouchernumber', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher Type', accessor: 'vouchertype', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Party Name', accessor: 'suppliername', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'PAN Number', accessor: 'pan_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Legal Entity', accessor: 'legalentity', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Taxable Amount', accessor: 'deductedamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TDS(%)', accessor: 'tdspercentage', formatType: 'number', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TDS Amount', accessor: 'tdsamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  {
    header: 'Amount After TDS',
    accessor: 'amountaftertds',
    formatType: 'currency',
    headerStyle: 'header',
    cellStyle: 'custonCurrenctStyle',
  },
  { header: 'TDS Details', accessor: 'tdsdetails', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
];

export const tcsExportColumns: ExportColumn[] = [
  { header: 'Date of deduction', accessor: 'invoicedate', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher No', accessor: 'vouchernumber', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher Type', accessor: 'vouchertype', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Party Name', accessor: 'suppliername', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'PAN Number', accessor: 'pan_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Legal Entity', accessor: 'legalentity', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Taxable Amount', accessor: 'deductedamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS(%)', accessor: 'tdspercentage', formatType: 'number', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'TCS Amount', accessor: 'tdsamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  {
    header: 'Amount After TCS',
    accessor: 'amountaftertds',
    formatType: 'currency',
    headerStyle: 'header',
    cellStyle: 'custonCurrenctStyle',
  },
  { header: 'TCS Details', accessor: 'tdsdetails', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
];

export const LedgerColumns: ExportColumn[] = [
  { header: 'Date', accessor: 'enteredtimestamp', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Account Name', accessor: 'accountname', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Against Account Name', accessor: 'oppositeaccountname', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher Type', accessor: 'vouchertype', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Voucher Number', accessor: 'vouchernumber', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Debit', accessor: 'totaldebitamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'Credit', accessor: 'totalcreditamount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'Balance', accessor: 'balance', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'Remarks', accessor: 'comments', formatType: 'text', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
];
export const posExportColumns: ExportColumn[] = [
  { header: 'Invoice Date', accessor: 'invoice_date', formatType: 'date', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Invoice No', accessor: 'invoice_no', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Party Name', accessor: 'customer_name', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Party Contact No.', accessor: 'phone_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Billing Currency', accessor: 'billing_currency', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Taxability', accessor: 'invoice_taxability', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Taxable Value ', accessor: 'taxable_value', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'IGST Amount', accessor: 'igst_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'CGST Amount', accessor: 'cgst_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'SGST/UTGST Amount', accessor: 'sgst_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  // { header: 'Cess Rate', accessor: 'phone_number', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
  { header: 'Cess Amount ', accessor: 'cess_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  {
    header: '(-)Additional Discount',
    accessor: 'additional_discount',
    formatType: 'currency',
    headerStyle: 'header',
    cellStyle: 'custonCurrenctStyle',
  },
  { header: 'TCS Amount', accessor: 'tcs_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'Round Off ', accessor: 'round_off', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  {
    header: 'Total GST Amount',
    accessor: 'total_gst_amount',
    formatType: 'currency',
    headerStyle: 'header',
    cellStyle: 'custonCurrenctStyle',
  },
  { header: 'Net Amount', accessor: 'net_amount', formatType: 'currency', headerStyle: 'header', cellStyle: 'custonCurrenctStyle' },
  { header: 'Status', accessor: 'status', formatType: 'text', headerStyle: 'header', cellStyle: 'body' },
];

export const exportFormats = ['excel', 'csv'] as const;

export const tcsAndTdsOptions: TcsTdsOption[] = [
  { value: 'TCSPAY', label: 'TCS Payable' },
  { value: 'TCSREC', label: 'TCS Receivable' },
  { value: 'TDSPAY', label: 'TDS Payable' },
  { value: 'TDSREC', label: 'TDS Receivable' },
];

export const receiptExportColumns: ExportColumn[] = [
  { header: 'Voucher No', accessor: 'voucher_no', formatType: 'text' },
  { header: 'Receipt Date', accessor: 'transaction_date', formatType: 'date' },
  { header: 'Received From (Cr)', accessor: 'paid_to', formatType: 'text' },
  { header: 'Received By (Dr)', accessor: 'paid_from', formatType: 'text' },
  { header: 'Mode', accessor: 'mode', formatType: 'text' },
  { header: 'Bank Reference Number', accessor: 'bank_reference_number', formatType: 'text' },
  { header: 'Amount', accessor: 'receipt_amount', formatType: 'currency' },
  // { header: 'Payable Amount', accessor: 'totalamount', formatType: 'text' },
  { header: 'TDS/TCS', accessor: 'tds_receivable_amount', formatType: 'currency' },
  { header: 'Total', accessor: 'total_amount', formatType: 'currency' },
  // { header: 'Amount Received in Cash/Bank A/c', accessor: 'receipt_amount', formatType: 'currency' },
  { header: 'Towards', accessor: 'towards', formatType: 'text' },
  { header: 'Remarks / Narration', accessor: 'comments', formatType: 'text' },
];

export const itemsExportColumns: ExportColumn[] = [
  { header: 'Type', accessor: 'itemtype', formatType: 'text' },
  { header: 'Item Code', accessor: 'itemcode', formatType: 'text' },
  { header: 'Item Name', accessor: 'itemname', formatType: 'text' },
  { header: 'Category', accessor: 'itemcategory', formatType: 'text' },
  { header: 'Unit', accessor: 'unit', formatType: 'text' },
  { header: 'HSN/SAC Code', accessor: 'hsn_sac_code', formatType: 'text' },
  { header: 'Show Item in invoice', accessor: 'show_item_in_invoice', formatType: 'text' },
  { header: 'Purchase A/c', accessor: 'purchase_account_name', formatType: 'text' },
  { header: 'Sales A/C', accessor: 'sales_account_name', formatType: 'text' },
  { header: 'Taxability', accessor: 'taxability', formatType: 'text' },
  // { header: 'Rate', accessor: 'amount', formatType: 'currency' },
  // { header: 'Discount', accessor: 'discounttype', formatType: 'currency' },
  // { header: 'Discount Amt', accessor: 'discountvalue', formatType: 'currency' },
  // { header: 'Taxable Amt', accessor: 'taxable', formatType: 'currency' },
  // { header: 'GST Rate', accessor: 'gstrate', formatType: 'currency' },
  // { header: 'Net Amount', accessor: 'netamount', formatType: 'currency' },
  // { header: 'Effective From', accessor: 'effectivedate', formatType: 'date' },
  // { header: 'Effective To', accessor: 'expireddate', formatType: 'date' },
  { header: 'Net Purchase Price', accessor: 'default_net_purchase_price', formatType: 'currency' },
  { header: 'Net Selling Price', accessor: 'default_net_selling_price', formatType: 'currency' },
];

export const customerExportColumns: ExportColumn[] = [
  { header: 'Customer Legal Name', accessor: 'partylegalname', formatType: 'text' },
  { header: 'Customer Ledger Name', accessor: 'partydisplayname', formatType: 'text' },
  { header: 'Customer Legal Entity', accessor: 'entity', formatType: 'text' },
  { header: 'Customer Group', accessor: 'accountgroup', formatType: 'text' },
  { header: 'Customer GSTIN', accessor: 'gstin', formatType: 'text' },
  { header: 'GST Category', accessor: 'gstcategory', formatType: 'text' },
  { header: 'Permanent Account Number (PAN)', accessor: 'pannumber', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'placeofsupply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billingcurrency', formatType: 'currency_name' },
  { header: 'Credit Limit Amount', accessor: 'creditlimitamount', formatType: 'currency' },
  { header: 'Credit Period Allowed (days)', accessor: 'creditperiodduration', formatType: 'text' },
  { header: 'Billing Address', accessor: 'partybillingaddress', formatType: 'text' },
  { header: 'Shipping Address', accessor: 'partydeliveryaddress', formatType: 'text' },
  // { header: 'Contact Person Details', accessor: 'creditlimitamount', formatType: 'text' },
  { header: 'Email', accessor: 'email', formatType: 'text' },
  { header: 'Mobile', accessor: 'contactnumber', formatType: 'text' },
  { header: 'Whatsapp', accessor: 'whatsappnumber', formatType: 'text' },
  { header: 'Comments', accessor: 'comments', formatType: 'text' },
];

export const supplierExportColumns: ExportColumn[] = [
  { header: 'Supplier Legal Name', accessor: 'partylegalname', formatType: 'text' },
  { header: 'Supplier Ledger Name', accessor: 'partydisplayname', formatType: 'text' },
  { header: 'Supplier Legal Entity', accessor: 'entity', formatType: 'text' },
  { header: 'Supplier Group', accessor: 'accountgroup', formatType: 'text' },
  { header: 'Supplier GSTIN', accessor: 'gstin', formatType: 'text' },
  { header: 'GST Category', accessor: 'gstcategory', formatType: 'text' },
  { header: 'Permanent Account Number (PAN)', accessor: 'pannumber', formatType: 'text' },
  { header: 'Place of Supply', accessor: 'placeofsupply', formatType: 'text' },
  { header: 'Billing Currency', accessor: 'billingcurrency', formatType: 'currency_name' },
  { header: 'Credit Limit Amount', accessor: 'creditlimitamount', formatType: 'text' },
  { header: 'Credit Period Allowed (days)', accessor: 'creditperiodduration', formatType: 'text' },
  { header: 'Billing Address', accessor: 'partybillingaddress', formatType: 'text' },
  { header: 'Shipping Address', accessor: 'partydeliveryaddress', formatType: 'text' },
  // { header: 'Contact Person Details', accessor: 'creditlimitamount', formatType: 'text' },
  { header: 'Email', accessor: 'email', formatType: 'text' },
  { header: 'Mobile', accessor: 'contactnumber', formatType: 'text' },
  { header: 'Whatsapp', accessor: 'whatsappnumber', formatType: 'text' },
  { header: 'Comments', accessor: 'comments', formatType: 'text' },
];

export const paymentExportColumns: ExportColumn[] = [
  { header: 'Voucher No', accessor: 'voucher_no', formatType: 'text' },
  { header: 'Payment Date', accessor: 'transaction_date', formatType: 'date' },
  { header: 'Paid From (Cr)', accessor: 'paid_to', formatType: 'currency' },
  { header: 'Paid To (Dr)', accessor: 'paid_from', formatType: 'currency' },
  { header: 'Mode', accessor: 'mode', formatType: 'text' },
  { header: 'Bank Reference Number', accessor: 'bank_reference_number', formatType: 'text' },
  { header: 'Amount', accessor: 'payment_amount', formatType: 'currency' },
  // { header: 'Payable Amount', accessor: 'totalamount', formatType: 'text' },
  { header: 'TDS/TCS', accessor: 'tds_payable_amount', formatType: 'currency' },
  { header: 'Total', accessor: 'total_amount', formatType: 'currency' },
  // { header: 'Amount Paid from Cash/Bank A/c', accessor: 'section', formatType: 'currency' },
  { header: 'Towards', accessor: 'towards', formatType: 'text' },
  { header: 'Remarks / Narration', accessor: 'comments', formatType: 'text' },
];

export const defaultExportStyles: ExportStyles = {
  header: {
    fontSize: 14,
    alignment: 'center',
    style: 'bold',
    color: '#000000',
  },
  body: {
    fontSize: 12,
    alignment: 'left',
    style: 'normal',
    color: '#333333',
  },
  custom: {
    fontSize: 32,
    alignment: 'center',
    style: 'bold',
    color: '#c90000ff',
  },
  customHead: {
    fontSize: 2,
    alignment: 'right',
    style: 'italic',
    color: '#24c239ff',
  },
  custonCurrenctStyle: {
    fontSize: 12,
    alignment: 'right',
    style: 'normal',
    color: '#333333',
  },
} as const;
